export const USER_AUTHENTICATION = "USER_AUTHENTICATION";
